/* Render the wishlist page's products as the THEME's product card, so the
   wishlist grid is the collection grid rather than something styled to
   resemble it.

   /a/wishlist-hero/wishlist is an app-proxy page: Wishlist Hero serves a
   Next.js document that Shopify embeds in the theme layout, and draws the
   cards itself with MUI. Why the cards are fetched rather than styled, how one
   is fetched, and how the flash guard works are all in theme-card-swap.js.

   The app's own list is not removed, only hidden. It is React's render target,
   deleting it invites the app to fight back, and it remains the source this
   script reads the wishlist's contents from. (Its "add all to cart" /
   "remove all" footer is hidden too - see base.css.)

   If anything here fails - offline, a 404 on a deleted product, the app
   changing its DOM - nothing is hidden and the app's own cards stay on screen
   with base.css's styling applied. That styling is the fallback path, which is
   why it was kept rather than deleted. */
(function () {
  var swap = window.ThemeCardSwap;
  if (!swap) return;

  var LISTING = '.wishlisthero-customer-view-listing';
  var APP_CARD = '.wishlist-hero-list-card';
  var GRID_ID = 'wishlist-theme-grid';

  /* Class list copied from the collection grid's own <ul>
     (sections/main-collection-product-grid.liquid). The wishlist-specific cap
     and gaps are in base.css under `.wishlist-product-grid`. */
  var GRID_CLASS = 'grid product-grid grid--2-col-tablet-down grid--4-col-desktop wishlist-product-grid';

  var guard = swap.createFlashGuard('wishlist-swap-pending', 8000);
  var lastSignature = null;
  var building = false;
  var removed = {};

  /* Add-to-cart asks the Cart API to re-render the drawer sections "as seen
     from" the current path. This page's path belongs to the app proxy, which
     the theme does not serve, and the API then returns no sections at all -
     the item lands in the cart but the drawer never opens. Point that lookup
     at a real theme route instead; the cart sections do not depend on which
     page asked for them. Read by product-card-form.js. */
  window.themeCartSectionsUrl = (window.routes && window.routes.root) || '/';

  function keyOf(item) {
    return item.handle + ':' + item.variant;
  }

  function listing() {
    return document.querySelector(LISTING);
  }

  /* The app renders two .MuiGrid-container children: an actions bar the theme
     already hides, and the real card row. The real one is whichever holds
     cards. */
  function appGrid() {
    var root = listing();
    if (!root) return null;
    var containers = root.querySelectorAll(':scope > .MuiGrid-container');
    for (var i = 0; i < containers.length; i++) {
      if (containers[i].querySelector(APP_CARD)) return containers[i];
    }
    return null;
  }

  /* Product identity comes from the card's own links rather than from
     WishListHero_SDK.GetWishListItems(), which answers 403 "available for
     paid plans only" on this shop. */
  function readItems() {
    var cards = document.querySelectorAll(APP_CARD);
    var items = [];
    for (var i = 0; i < cards.length; i++) {
      var parsed = swap.readProductLink(cards[i].querySelector('a[href*="/products/"]'));
      if (!parsed) continue;
      parsed.appCard = cards[i];
      /* The app's list is stale after a removal made through the SDK - it
         keeps rendering the row it no longer has. Filtering here stops a
         rebuild from resurrecting a product the shopper just removed. */
      if (removed[keyOf(parsed)]) continue;
      items.push(parsed);
    }
    return items;
  }

  /* The theme card ships the same `.wishlist-hero-custom-button` the app binds
     on every other template, with the data-wlh-* attributes already on it. The
     app does not bind it here - it only scans on its own pages, and an
     injected node misses that pass - so the button is asked to bind itself.

     Drawing and clicking are handled separately, because the SDK does the
     first well and the second only halfway.

     DRAWING - WishListHero_SDK.InitializeAddToWishListButton renders the real
     control in the correct "Remove from wishlist" state. Two quirks, both
     established by probing the live SDK rather than from docs: it resolves its
     target with querySelector('.' + ButtonClassElement), i.e. the FIRST match,
     so each button needs its own throwaway class; and `WishlistHash` is
     required by its validator while GetWishListHash() answers 403 on this
     shop - an empty string satisfies it and the button still initialises.

     CLICKING - the SDK button's own handler does remove the product, but does
     not tell the app's React list, which keeps rendering the row it no longer
     has. Forwarding the click to the app's own per-row remove button was tried
     and does not work: that button ignores a scripted `.click()` and a full
     synthetic pointer sequence, hidden or visible - it only responds to a
     trusted event. So the SDK's removal is left to run and the list is
     reconciled here, guarded so a failed removal leaves the card on screen.
     When the last row goes the page reloads, because the app owns the
     "there are no items in this wishlist" empty state and only renders it on
     a fresh load. */
  function initHearts(built) {
    var stamp = String(Date.now());

    built.forEach(function (entry, index) {
      var heart = swap.bindWishlistHeart(entry.node, 'wlh-bind-' + stamp + '-' + index);
      if (!heart) return;
      if (heart.dataset.wlhBound === 'true') return;
      heart.dataset.wlhBound = 'true';

      heart.addEventListener('click', function () {
        window.setTimeout(function () {
          var button = heart.querySelector('button');
          var stillListed = button &&
            button.className.indexOf('wishlisthero-product-in-wishlist') !== -1;
          if (stillListed) return;

          removed[keyOf(entry.item)] = true;
          lastSignature = null;

          var row = entry.node.parentNode;
          var grid = row && row.parentNode;
          if (row && grid) grid.removeChild(row);
          if (grid && grid.children.length === 0) window.location.reload();
        }, 900);
      });
    });
  }

  function render(built) {
    var root = listing();
    var app = appGrid();
    if (!root || !built.length) return;

    var grid = document.createElement('ul');
    grid.id = GRID_ID;
    grid.className = GRID_CLASS;
    grid.setAttribute('role', 'list');

    built.forEach(function (entry) {
      var li = document.createElement('li');
      li.className = 'grid__item';
      li.appendChild(entry.node);
      grid.appendChild(li);
    });

    var existing = document.getElementById(GRID_ID);
    if (existing) existing.parentNode.removeChild(existing);

    if (app) {
      app.classList.add('wishlist-app-grid--replaced');
      app.parentNode.insertBefore(grid, app);
    } else {
      root.insertBefore(grid, root.firstChild);
    }

    initHearts(built);
  }

  function build() {
    if (building) return;
    var items = readItems();

    if (!items.length) {
      var stale = document.getElementById(GRID_ID);
      if (stale) stale.parentNode.removeChild(stale);
      lastSignature = null;
      /* Either the app has not rendered yet, or the wishlist is genuinely
         empty and the app's own empty state should show. Only reveal in the
         second case - revealing in the first would flash the very cards this
         is meant to hide. */
      if (listing()) guard.reveal();
      return;
    }

    /* Rebuilding on every mutation would loop: inserting the grid mutates the
       same subtree the observer watches. Keyed on the product list, so a
       rebuild only happens when the wishlist's contents actually changed. */
    var signature = items.map(keyOf).join('|');
    /* Also rebuild when the grid is gone: the app re-renders its list for
       reasons that do not change the wishlist's contents, which removes this
       grid while leaving the signature identical. Without this the page would
       fall back to the app's own cards and never recover. */
    var mounted = document.getElementById(GRID_ID);
    if (signature === lastSignature && mounted) return;
    lastSignature = signature;
    building = true;
    /* Restart the failsafe now that real work has started, so a slow cold
       load cannot trip it mid-fetch and flash the app's cards. */
    if (guard.held()) guard.claim();

    Promise.all(items.map(function (item) {
      return swap.fetchCard(item.handle, item.variant)
        .then(function (node) { return { item: item, node: node }; })
        .catch(function (error) {
          if (window.console) console.warn('[wishlist] ' + error.message);
          return null;
        });
    })).then(function (results) {
      building = false;
      var built = results.filter(Boolean);
      /* All-or-nothing: a partial grid next to a hidden app grid would drop
         items from the shopper's wishlist without saying so. */
      if (built.length === items.length) render(built);
      else lastSignature = null;
      guard.reveal();
    }).catch(function () {
      building = false;
      lastSignature = null;
      guard.reveal();
    });
  }

  /* Claimed at parse time rather than in init, so the class is on <html>
     before the app's bundle can render its first card. */
  guard.claim();

  function init() {
    swap.observeDocument(build);
    build();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
